import { hot } from 'react-hot-loader';
import Seo from '../components/Seo';
import Footer from '../components/Footer';
import ScreenTraits from '../screens/ScreenTraits';



function TraitsPage(props) {
  return (
    <Seo title={'Traits'} meta={[]}>
      <ScreenTraits />
      <Footer />
    </Seo>
  );
};

export default hot(module)(TraitsPage);
